export default "__VITE_ASSET__CgZzLT4v__"